export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

//时间格式化-去掉T和Z
export function formatTime(time) {
  if (time) {
    return time.replace("T", " ").replace("Z", "");
  }
}
// 格式化时长
export function formatDuration(seconds) {
  if (!seconds && seconds !== 0) return '00:00:00'

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    secs.toString().padStart(2, '0')
  ].join(':')
}


//返回32960数据解析
export function getCommon32960Value(value, type) {
  switch (value) {
    case 0xff: return "无效";
    case 0xfe: return "异常";
    case 0xffff: return "无效";
    case 0xfffe: return "异常";
    case 0xffffffff: return "无效";
    case 0xfffffffe: return "异常";
    default: {
      //不同的类型，显示不同的计算值
      switch (type) {
        case "Speed":
          return value / 10.0;
        case "TotalMileage":
          return value / 10.0;
        case "Voltage":
          return value / 10.0;
        case "Electric":
          return (value / 10.0 - 1000.0).toFixed(1);
        case "Temperature":
          return (value - 40);
        case "RotateSpeed":
          return (value - 20000);
        case "Torque":
          return (value / 10 - 2000);
        case "CrankshaftSpeed":
          return (value * 0.1).toFixed(1);
        case "FuelConsumRate":
          return (value * 0.01).toFixed(2);
        case "BatteryMonomerVoltageValue":
          return (value * 0.001).toFixed(3);
        default:
          return value;
      }
    }
  }
}

// 防抖函数
export function debounce(func, delay) {
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
